import constants from 'constants/index'

const statusLabel = (status) => {
  if (status == null) return 'null'
  switch ((status || '').toLowerCase()) {
    case constants.accounts.STATUSES.PENDING_STATUS:
      return constants.accounts.STATUSES_LABELS.PENDING_LABEL
    case constants.accounts.STATUSES.UNDER_REVIEW_STATUS:
      return constants.accounts.STATUSES_LABELS.UNDER_REVIEW_LABEL
    case constants.accounts.STATUSES.APPROVED_STATUS:
      return constants.accounts.STATUSES_LABELS.APPROVED_LABEL
    case constants.accounts.STATUSES.REFUSED_STATUS:
      return constants.accounts.STATUSES_LABELS.REFUSED_LABEL
    default:
      return ''
  }
}

export default statusLabel
